import { o as otto } from "../chunks/nexus-client-client-TGyNJoMo.mjs";
const reco = otto.reco;
export {
  reco
};
/*                                     */
